<style scoped>

</style>

<template>
  <div
    class=""
    style="display: flex; flex-direction: column; justify-content: space-between;"
  >
    <div v-if="!$store.state.activeTemplate.isWizardEnabled" class="section-title-container">
<!--      <div class="section-title">{{ translate(section.title) }}</div>-->
    </div>

    <div>
      <v-text-field
        id="section_wc__minimum_cash_balance_percent_input"
        :rules="[ isAssumpitonValid ]"
        :label="this.translate('ui_minimum_cash_balance_percent')"
        v-model="$store.state.activeTemplate.data.options.wc.minCashBalance"
        required
        outlined
        dense
        background-color="white"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-text-field>

      <v-text-field
        id="section_wc__accounts_receivable_period_input"
        :rules="[ isAssumpitonValid ]"
        :label="this.translate('ui_accounts_receivable_period')"
        v-model="$store.state.activeTemplate.data.options.wc.accountsReceivablePeriod"
        required
        outlined
        dense
        background-color="white"
        :suffix="translate('ui_assumptions_wc_days')"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-text-field>

      <v-text-field
        id="section_wc__inventory_period_input"
        :rules="[ isAssumpitonValid ]"
        :label="this.translate('ui_inventory_period')"
        v-model="$store.state.activeTemplate.data.options.wc.inventoryPeriod"
        required
        outlined
        dense
        background-color="white"
        :suffix="translate('ui_assumptions_wc_days')"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-text-field>

      <v-text-field
        id="section_wc__accounts_payable_period_input"
        :rules="[ isAssumpitonValid ]"
        :label="this.translate('ui_accounts_payable_period')"
        v-model="$store.state.activeTemplate.data.options.wc.accountsPayablePeriod"
        required
        outlined
        dense
        background-color="white"
        :suffix="translate('ui_assumptions_wc_days')"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-text-field>
    </div>
    <DialogSection :section="section" :selectNextSection="selectNextSection"/>

<!--    <DialogToolbarBottom v-if="shouldShowToolbarBottom" :section="section"/>-->

  </div>
</template>

<script>

// import DialogToolbarBottom from '@/components/dialogs/DialogToolbarBottom.vue';
import DialogSection from '@/components/dialogs/DialogSection';
import Mixin from '../../mixins/mixin';


export default {
  name: 'WCEditDialog',
  components: {
    DialogSection,
    // DialogToolbarBottom,
  },
  mixins: [Mixin],
  props: ['section', 'selectNextSection'],
  data: () => ({
    dialogAssumptions: [],
  }),
  computed: {
    shouldShowToolbarBottom() {
      return !this.section.isInitialized;
      // const { isWizardEnabled } = this.$store.state.activeTemplate;
      // const whenWizardEnabled = this.section.isEditingSettings && this.section.isInitialized;
      // return !isWizardEnabled || (isWizardEnabled && whenWizardEnabled);
    },
  },
  methods: {
    getDialogConfig() {
      const { resourceRel } = this.section.coreResourceTypes[0];
      const newSectionResource = this.createNewSectionResource(this.section, resourceRel);

      const addResourceLabel = `${this.translate(this.section.addResourceLabel)}`;

      const formulas = this.getFormulas(newSectionResource);
      // eslint-disable-next-line
      const units = newSectionResource.flows[0].fcst.map((fcst) => {
        return fcst.scenarios[0].units;
      });

      const title = `${this.translate('ui_add_btn')} ${addResourceLabel}`;
      this.$store.commit('updateState', {
        path: 'dialogs.editResourceDialogVisible',
        value: true,
      });

      const config = {
        title,
        formulas,
        section: this.section,
        resource: newSectionResource,
        onScrollDisabled: false,
        initialStep: 2,
      };

      this.dialogConfig = config;

      return config;
    },
  },
};
</script>
